import { deleteClient } from "@/api/client";
import { BaseExpandableRow } from "@/components/_Shared/Table/UI/ExpandableRow/ExpandableRow";
import { ExpandableRowButtonContainer } from "@/components/_Shared/Table/UI/ExpandableRow/ExpandableRowButtonContainer";
import { OrangeButton, RouteButton } from "@/components/Buttons";
import { ClientProps } from "@/interfaces/client_types";

export function ClientRow({data}: {data: ClientProps}) {
    const handleDelete = async() => {
        if (confirm("Are you sure you want to delete this Client?")) {
            const response = await deleteClient(data.uuid)
            if (response.operation == "COMPLETED") {
                alert("Client deleted successfully")
                window.location.reload()
            } else {
                alert("Failed to delete Client: " + response.message)
            }
        }
    }
    return (
        <BaseExpandableRow>
            <ExpandableRowButtonContainer>
                <RouteButton route={"/clients/update_client/" + data.uuid} text="Edit" />
                <OrangeButton onClick={handleDelete}>
                    Delete Client
                </OrangeButton>
            </ExpandableRowButtonContainer>
        </BaseExpandableRow>
    )
}